import React, { useRef, useEffect, useState } from 'react';
import classnames from 'classnames';
import TopNav from './TopNav';
import SideNav from '../../sideNav';
import Hero from './hero';
import ValueProps from 'scy/ValueProps';
import MediaLogos from 'scy/MediaLogos';
import FAQ from './faq';
import Categories from './categories';
import Testimonials from './Testimonials';
import Territories from './Territories';
import Footer from '../../footer';
import AsyncLeadCaptureModal from 'components/leadCaptureModal/async';
import { track } from 'shared/models/analytic';
import { borderBox, textCenter } from 'scy/utils.mod.scss';
import { MutedBackground } from 'scy/Background';
import { WideContainer } from 'scy/layouts';
import { H2Alt } from 'scy/text';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';
import { slideoutPanel } from '../../sideNav/styles.mod.scss';
import DropIcon from 'images/icons/logos/drop.svg?react-svg';
import MixingIcon from 'images/icons/logos/mixing.svg?react-svg';
import PinIcon from 'images/icons/logos/pin.svg?react-svg';
import {
  InstallBanner,
  InstallBannerMinimized
} from 'components/InstallBanner';
import { isIos } from 'shared/utils';

export default function HomeLandingPage() {
  const [isInstallBannerVisible, setIsInstallBannerVisible] = useState(true);
  const [isMinimizedBannerVisible, setIsMinimizedBannerVisible] = useState(
    false
  );

  useEffect(() => {
    track('Landing Page Viewed');
  }, []);

  const valuePropsId = 'value-props';

  const panelRef = useRef();
  const toggleRef = useRef();

  const handleMinimizeBanner = () => {
    setIsInstallBannerVisible(!isInstallBannerVisible);
    setIsMinimizedBannerVisible(!isMinimizedBannerVisible);
  };

  const handleMinimizedBannerDismissed = () => {
    setIsMinimizedBannerVisible(!isMinimizedBannerVisible);
  };

  return (
    <div className={borderBox}>
      {isIos() && isInstallBannerVisible ? (
        <InstallBanner handleMinimizeBanner={handleMinimizeBanner} />
      ) : isMinimizedBannerVisible ? (
        <InstallBannerMinimized
          handleMinimizedBannerDismissed={handleMinimizedBannerDismissed}
          handleMinimizeBanner={handleMinimizeBanner}
        />
      ) : null}
      <main ref={panelRef} className={slideoutPanel}>
        <TopNav valuePropsId={valuePropsId} toggleRef={toggleRef} />
        <Hero />
        <ValueProps
          id={valuePropsId}
          title={'How to get Saucey'}
          listItems={config}
        />

        <MutedBackground className={styles.logoBg}>
          <WideContainer
            tag="section"
            className={classnames(
              padding.top_md,
              padding.bottom_md,
              padding.tablet_top_lg,
              padding.tablet_bottom_lg
            )}
          >
            <MediaLogos />
          </WideContainer>

          <WideContainer tag="section">
            <Categories />
          </WideContainer>

          <WideContainer
            tag="section"
            className={classnames(
              padding.top_md,
              padding.bottom_md,
              padding.tablet_top_xl,
              padding.tablet_bottom_xl,
              textCenter
            )}
          >
            <H2Alt
              marginClass={classnames(
                margin.top_md,
                margin.bottom_md,
                margin.tablet_bottom_lg
              )}
            >
              People Love Us
            </H2Alt>
            <Testimonials />
          </WideContainer>
        </MutedBackground>

        <Territories />
        <FAQ />
        <Footer />
        <AsyncLeadCaptureModal />
      </main>

      <SideNav panelRef={panelRef} toggleRef={toggleRef} />
    </div>
  );
}

export const config = [
  {
    icon: <DropIcon width={60} height={80} />,
    title: 'The whole liquor store',
    subtitle: 'Fan favorites, seasonal booze, and local picks.'
  },
  {
    icon: <MixingIcon width={52} height={110} />,
    title: 'In 30 min',
    subtitle: 'We’re already on our way—no need to get up.'
  },
  {
    icon: <PinIcon width={60} height={80} />,
    title: 'At the drop of a pin',
    subtitle: 'We’re outside—Cheers! See you for round two.'
  }
];
